import { isEmptyString } from './isEmptyString';

export const isValidLetters = (value: unknown): boolean =>
  !isEmptyString(value) && /^[А-Яа-я\s]*$/.test(value as string);
